"use client";

import { CategoryFaq, ProdDetailFaq } from "@/services/dataTypes";
import { useState } from "react";

interface Props {
  faq: CategoryFaq | ProdDetailFaq;
  index: number;
}

const CategoryFaqsAccordion = ({ faq, index }: Props) => {
  const [isOpen, setIsOpen] = useState(index === 0);

  return (
    <div className="border border-[#800000]/10 rounded-2xl overflow-hidden transition-all duration-300">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 bg-white hover:bg-[#800000]/[0.02] transition-colors duration-200 text-left group"
        aria-expanded={isOpen}
      >
        <span className="text-sm font-bold text-[#1A1A1A] leading-snug group-hover:text-[#800000] transition-colors duration-200">
          {faq.question}
        </span>
        <span
          className={`flex-shrink-0 w-6 h-6 rounded-full border border-[#800000]/20 flex items-center justify-center transition-all duration-300 ${
            isOpen ? "bg-[#800000] border-[#800000] rotate-180" : "bg-white"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke={isOpen ? "#fff" : "#800000"}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      <div
        className={`transition-all duration-300 overflow-hidden ${
          isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-5 pb-5 pt-1 bg-[#fffde0]/60 border-t border-[#800000]/5">
          <p className="text-sm text-slate-600 leading-relaxed">{faq.answer}</p>
        </div>
      </div>
    </div>
  );
};

export default CategoryFaqsAccordion;
